export const iconFontAwesomeEmojiFaceLaugh = (
	<i className="fa-solid fa-face-laugh"></i>
);
